import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { LineChartComponent } from '../../shared/components/line-chart/line-chart.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import { IEvolutionReport } from '../../utils/interfaces/evolution-report';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { PrintDocument } from '../print-document';

@Component({
  selector: 'app-print-evolution',
  standalone: true,
  host: {
    '[class.embedded]': 'embedded()',
  },
  imports: [CommonModule, PrintFilterDataComponent, LineChartComponent],
  templateUrl:
    '../../main/report/report-data/evolution/evolution.component.html',
  styles: [
    `
      :host.embedded app-print-filter-data {
        display: none;
      }
    `,
  ],
})
export class PrintEvolutionComponent
  extends PrintDocument
  implements OnInit, AfterViewInit
{
  embedded = input(false);
  embeddedData = input<IEvolutionReport[] | null>(null);
  embeddedFilter = input<IReportFilter | null>(null);

  print = true;
  private readonly titleService = inject(Title);
  data!: IEvolutionReport[];
  filter!: IReportFilter;

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    if (this.embedded()) {
      this.data = this.embeddedData() ?? [];
      this.filter = this.embeddedFilter() as IReportFilter;
      return;
    }

    const { data, filter } = this.activatedRoute.snapshot.data['data'];

    this.data = data;
    this.filter = filter;

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório de evolução',
        this.filter.startDate,
        this.filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    if (this.embedded()) {
      return;
    }

    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }
}
